import * as React from 'react';
import { forwardRef, useEffect, useRef } from 'react';

import {
  TextAreaFormControl,
  type TextAreaFormControlProps,
  type TextAreaFormControlType,
} from './text_area_form_control';

const DEFAULT_STYLE = { overflow: 'hidden', resize: 'none' } as const;

const resize = (target: HTMLTextAreaElement) => {
  target.style.height = 'auto';
  target.style.height = `${target.scrollHeight}px`;
};

export type ResizableTextAreaFormControlProps = TextAreaFormControlProps;
export type ResizableTextAreaFormControlType = TextAreaFormControlType;

export const ResizableTextAreaFormControl = forwardRef<
  ResizableTextAreaFormControlType,
  ResizableTextAreaFormControlProps
>(({ onChange, style, rows = 1, value, ...props }, ref) => {
  const iref = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    const element = iref.current;
    if (element) resize(element);
  }, [value]);

  return (
    <TextAreaFormControl
      ref={(element) => {
        iref.current = element;
        if (typeof ref === 'function') ref(element);
        else if (ref) ref.current = element;
      }}
      style={{ ...DEFAULT_STYLE, ...style }}
      {...props}
      rows={rows}
      value={value}
      onChange={(event) => {
        onChange?.(event);
        resize(event.target);
      }}
    />
  );
});
